import {useRef, useState, useMemo, useEffect} from 'react'

export const useFilters = (initialFilters, data, config, text, isRangeSelected = false) => {
    const [filterSettings, setFilterSettings] = useState(initialFilters)
    const [isFilterApplied, setIsFilterApplied] = useState(true)
    const tempFiltersRef = useRef(initialFilters)

    useEffect(() => {
        setFilterSettings(initialFilters)
        tempFiltersRef.current = initialFilters
    }, [text])

    const saveTempFilters = () => {
        tempFiltersRef.current = {...filterSettings}
        setIsFilterApplied(false)
    }

    const applyTempFilters = () => {
        tempFiltersRef.current = {...filterSettings}
        setIsFilterApplied(true)
    }

    const restorePreviousFilters = () => {
        if (!isFilterApplied) {
            setFilterSettings(tempFiltersRef.current)
        }
    }

    const filteredData = useMemo(() => {
        let result = data?.length > 0 ? [...data] : []
        config.forEach((item) => {
            const value = filterSettings[item.key]
            const applyFilter = item.filterFn
            if (applyFilter && value) {
                result = applyFilter(result, value, isRangeSelected)
            }
        })
        return result
    }, [data, filterSettings, config])

    const resetFilterSettings = () => {
        setFilterSettings(initialFilters)
        tempFiltersRef.current = initialFilters
        setIsFilterApplied(true)
    }

    return {
        filterSettings,
        setFilterSettings,
        filteredData,
        resetFilterSettings,
        saveTempFilters,
        applyTempFilters,
        restorePreviousFilters
    }
}
